import { Component } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ProviderPriceService } from '../provider-price.service';

@Component({
  selector: 'app-upload-brand-result',
  templateUrl: './upload-brand-result.component.html',
  styleUrls: ['./upload-brand-result.component.scss']
})
export class UploadBrandResultComponent {
  brands: { brand: string }[] = [];

  constructor(private providerPriceService: ProviderPriceService) {
    this.getNewBrands();
  }

  async getNewBrands() {
    this.brands = await firstValueFrom(this.providerPriceService.getNewBrands());
  }
}
